<template xmlns:th="http://www.w3.org/1999/xhtml">
    <div class="user">
<!--        <el-card class="noprint">-->
<!--            <el-page-header v-if="from == 'order'" @back="goBack" :content="'签收单 ('+ orderId + ')'"></el-page-header>-->
<!--            <el-breadcrumb v-if="from == 'menu'" separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>订单管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>签收单</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <div style="background: #fff; padding: 10px">
<!--                <div style="text-align: right;padding-bottom: 10px" >-->
<!--                    <el-button type="primary" size="mini" @click="exportUser()">导出</el-button>-->
<!--                </div>-->

                <div style="margin-top: 3px;">
                    <table border="1" cellspacing="0" style="table-layout: fixed; width: 100%;font-size:13px">
                        <colgroup>
                            <col width="110"/>
                            <col width="130"/>
                            <col/>
                            <col width="160"/>
                            <col width="110"/>
                            <col width="80"/>
                            <col width="100"/>
                            <col width="110"/>
                            <col width="160"/>
                        </colgroup>
                        <tbody>
                            <tr style="width: 100%">
                                <td height="80" colspan="9" style="padding: 0 5px;text-align: center;font-weight: bold;font-size: 20px" >供货单<br>Delivery Note</td>
                            </tr>
                            <tr style="width: 100%;font-size: 15px;font-weight: normal" >
                                <th style="width: 120px;" class="thStyle">收货方：</th>
                                <td height="30" class="tdStyle" colspan="3" style="width: 467px;padding: 0 5px;" >{{allData.invoiceCompanyName}}</td>
                                <th style="width: 120px;" class="thStyle">发货方：</th>
                                <td colspan="4" height="30" class="tdStyle" style="width: 467px;padding: 0 5px;" >北京鹏龙天创物资贸易有限公司</td>
                            </tr>
                            <tr style="width: 100%">
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">交货地点：</th>
                                <td colspan="3"  class="tdStyle" style="width: 467px;padding: 0 5px;" height="30">{{allData.address}}</td>
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">发货联系人：</th>
                                <td style="width: 168px;padding: 0 5px;" class="tdStyle" height="30" colspan="2"></td>
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">电话：</th>
                                <td style="width: 167px;padding: 0 5px;" class="tdStyle"></td>
                            </tr>
                            <tr style="width: 100%">
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">采购订单号PO：</th>
                                <td colspan="3" style="width: 467px;padding: 0 5px;"  class="tdStyle" height="30">{{allData.orderNo}}</td>
                                <th style="width: 120px;" class="thStyle" >物流公司：</th>
                                <td colspan="4" style="width: 467px;padding: 0 5px;" ></td>
                            </tr>
                            <tr style="width: 100%">
                                <th style="width: 120px;" class="thStyle">采购工程师：</th>
                                <td colspan="3" style="width: 467px;padding: 0 5px;"  class="tdStyle" height="30" >{{allData.consignee}}</td>
                                <th style="width: 120px;" class="thStyle">物流单号：</th>
                                <td colspan="4" style="width: 467px;padding: 0 5px;"  class="tdStyle" ></td>
                            </tr>
                            <tr style="width: 100%">
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">技术工程师：</th>
                                <td colspan="3" style="width: 467px;padding: 0 5px;" height="30"  class="tdStyle" >{{allData.engineer}}</td>
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">物流联系人：</th>
                                <td style="width: 168px;padding: 0 5px;" colspan="2"></td>
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">电话：</th>
                                <td style="width: 167px;padding: 0 5px;"></td>
                            </tr>
                            <tr style="width: 100%">
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">收货人及电话：</th>
                                <td colspan="3" style="width: 467px;padding: 0 5px;" height="30" >{{allData.consignee+","+allData.mobile}}</td>
                                <th style="width: 120px;background: #dfdfdf;" class="thStyle">到货时间：</th>
                                <td colspan="4" style="width: 467px;padding: 0 5px;" ></td>
                            </tr>
                            <tr style="width: 100%;background: #dfdfdf;">
                                <th style="width: 60px">序号<br>Item</th>
                                <th style="width: 60px">物料号<br>SRM No.</th>
                                <th style="width: 120px">产品名称<br>Description</th>
                                <th style="width: 120px">型号&订货号<br>Type No.&Order No</th>
                                <th style="width: 120px">品牌<br>Brand</th>
                                <th style="width: 120px">单位<br>Unit</th>
                                <th style="width: 120px">总数量<br>Total quantity</th>
                                <th style="width: 120px">到货数量<br>Arrival quantity</th>
                                <th style="width: 120px">备注<br>Remark</th>
                            </tr>
                            <tr style="width: 100%" v-for="(detail,index) in tableData" v-bind:key="index">
                                <td style="padding: 0 5px;text-align: center">{{detail.number}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.sku}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.name}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.model}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.brand}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.unit}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.num}}</td>
                                <td style="padding: 0 5px;text-align: center">{{detail.num}}</td>
                                <td style="padding: 0 5px;text-align: center"></td>
                            </tr>
                        </tbody>


<!--                        <tr style="width: 100%" th:each="">-->
<!--                            <td align="center" style="padding: 0 5px; width: 50px;" th:text="${detail.sku}">序号</td>-->
<!--                            <td align="center" style="padding: 0 5px; width: 110px" th:text="${detail.sku}">商品编码</td>-->
<!--                            <td style="padding: 0 5px;" th:text="${detail.name}">产品名称</td>-->
<!--                            <td style="padding: 0 5px;width: 120px" th:text="${detail.brand}">品牌</td>-->
<!--                            <td style="padding: 0 5px;width: 120px" th:text="${detail.model}">规格型号</td>-->
<!--                            <td align="right" style="padding: 0 5px;width: 80px" th:text="${detail.num + (detail.unit == null ? '件' : detail.unit)}">数量</td>-->

<!--                        </tr>-->

                    </table>
                </div>
                <div style="margin-top: 20px; font-size: 14px; display: flex;">
                    <span style="flex-grow: 1;">送货人：</span>
                    <span style="flex-grow: 1;">收货人：</span>
                </div>
<!--                <el-table border-->
<!--                    :data="tableData"-->
<!--                    v-loading="loading"-->

<!--                    style="width: 100%;border-color: black">-->

<!--                    <el-table-column style="border-color: black"-->
<!--                        prop="number"-->
<!--                        label="序号Item"-->
<!--                        width="80" align="center">-->
<!--                        <template slot="header">-->
<!--                            <div>序号</div>-->
<!--                            <div>Item</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column width="170"-->
<!--                            prop="sku" align="center">-->
<!--                        <template slot="header">-->
<!--                            <div>物料号</div>-->
<!--                            <div>SRM No.</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column width="170"-->
<!--                                     prop="name"-->
<!--                                     align="center">-->
<!--                        <template slot="header">-->
<!--                            <div>产品名称</div>-->
<!--                            <div>Description</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column width="170"-->
<!--                                     prop="model"-->
<!--                                     align="center">-->
<!--                        <template slot="header">-->
<!--                            <div>型号&订货号</div>-->
<!--                            <div>Type No.&Order No.</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column width="170"-->
<!--                                     prop="brand" align="center">-->
<!--                        <template slot="header">-->
<!--                            <div>品牌</div>-->
<!--                            <div>Brand</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column width="170"-->
<!--                                     prop="unit"  align="center">-->
<!--                        <template slot="header">-->
<!--                            <div>单位</div>-->
<!--                            <div>Unit</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column width="170"-->
<!--                                     prop="num" align="center">-->
<!--                        <template slot="header">-->
<!--                            <div>总数量</div>-->
<!--                            <div>Total quantity</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column width="170"-->
<!--                                     prop="num" align="center">-->
<!--                        <template slot="header">-->
<!--                            <div>到货数量</div>-->
<!--                            <div>Arrival quantity</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
<!--                    <el-table-column width="170"-->
<!--                                     prop="remarks"-->
<!--                                     label="备注Remark" align="center">-->
<!--                        <template slot="header">-->
<!--                            <div>备注</div>-->
<!--                            <div>Remark</div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->

<!--                </el-table>-->
            </div>
        </main>
    </div>
</template>
<script>
    import {convertRes2Blob, downloadByPost} from "../../utils/download";

    export default {

    data() {
        //此处即表单发送之前验证
        let validateNewPassword2 = (rule, value, callback) => {
            if (value !== "" && value !== this.editForm.password) {
                callback(new Error('两次密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            selectData:[],
            allData:{},
            searchForm: {
                name: "",
                email: "",
                mobile: "",
                password: "",
                // type: "",
                // vip: "",
                companyTaxCode: "",
                businessLicense: "",
                status: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            editForm: {
                id: "",
                name: "",
                email: "",
                mobile: "",
                password: "",
                rPassword: "",
                type: "1",

            },
            isEdit: true,
            mdyPasswordDialogVisible: false,
            editRoleVisible: false,
            userId: "",
            uploadDialogVisible: false,
            uploadCheckResult: "",
            rules: {

                password: [
                    { required: true, message: '请设置新密码', trigger: 'blur' }
                ],
                rPassword: [
                    { required: true, message: '请确认新密码', trigger: 'blur' },
                    { validator: validateNewPassword2, trigger: 'blur' }
                ]
            }
        }
    },
    props: ["from", "orderId"],
    methods: {
        onSearch() {


            this.loading = true;
            let _this = this
            this.$axios.post("/admin/order/settlementDeliverDetail",this.orderId).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.loading = false;
                    let s = resp.data;
                    _this.tableData = s.list;
                    _this.allData = s;
                }
            }).catch(function() {
            });
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEdit(_index, row) {
            this.isEdit = true;
            this.editForm.id = row.id;
            this.editForm.name = row.name;
            this.editForm.email = row.email;
            this.editForm.mobile = row.mobile;
            // this.editForm.vip = row.vip+ "";
            // this.editForm.type = row.type+ "";
            this.editForm.status = row.status + "";
            this.editDialogVisible = true;
        },
        handleResetPassword(index, row) {

            this.editForm.id = row.id;
            this.editForm.password = "";
            this.editForm.rPassword = "";
            this.editForm.type = row.type;
            this.mdyPasswordDialogVisible = true;
        },
        handleClose() {},
        uploadSuccess(response) {
            const {header: {status, msg}} = response;
            this.$refs.upload.clearFiles();
            if(status === 0) {
                this.$notify({
                    title: '成功',
                    message: '数据保存成功',
                    type: 'success'
                });
                this.uploadDialogVisible = false;
                this.onSearch();
            } else {
                this.uploadCheckResult = msg;
            }
        },
        goBack() {
            this.$router.go(-1);
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        exportUser(){
            if(this.selectData.length == 0){
                this.$message({
                    type: 'info',
                    message: '请选择要导出的用户',
                    duration: 2000
                });
                return;
            }
            const that = this;
            let arr = [];
            let val = this.selectData;
            if(val.length>0){
                for(let i=0; i<val.length; i++){
                    arr.push(val[i].id);
                }
                downloadByPost({
                    axios: that.$axios,
                    url: "/admin/easypoi/users",
                    data: {ids:arr,companyId:that.companyId},
                    success: response => {
                        convertRes2Blob(response);
                    },
                });
            }
        },
    },
    created() {
        this.onSearch()
    },
}
</script>
<style>
    /*表头换行 加这段代码*/
    .table ::v-deep.el-table th.el-table__cell > .cell {
        white-space: pre;
    }
    /*表格表头样式*/
    .table ::v-deep.el-table .el-table__cell {
        padding: 0px;
        min-width: 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        text-overflow: ellipsis;
        vertical-align: middle;
        position: relative;
        text-align: left;
    }
    .tdStyle{
        font-size: 13px;
        font-weight: normal
    }
    .thStyle{
        background: #dfdfdf;font-size:13px;text-align: left;padding-left: 5px;
    }

</style>
